import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, withKeys as _withKeys, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3e9d45ea"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-nav pt-x3 px-x3 xl:px-x8" }
const _hoisted_2 = { class: "main-nav-left" }
const _hoisted_3 = {
  class: "flex items-center list-reset gap-17",
  role: "menubar"
}
const _hoisted_4 = ["href", "reserve-space-for-bold-name", "aria-owns", "aria-expanded", "onKeydown", "onClick"]
const _hoisted_5 = { class: "main-nav-logo" }
const _hoisted_6 = ["href", "aria-label"]
const _hoisted_7 = { class: "sr-only" }
const _hoisted_8 = { class: "main-nav-right" }
const _hoisted_9 = {
  class: "flex items-center gap-12 xl:gap-24",
  role: "menubar"
}
const _hoisted_10 = ["href", "reserve-space-for-bold-name", "aria-owns", "aria-expanded", "onKeydown", "onClick"]
const _hoisted_11 = {
  role: "none",
  class: "flex items-center"
}
const _hoisted_12 = ["aria-expanded", "title", "onKeydown", "onClick"]
const _hoisted_13 = ["href", "aria-label", "aria-owns", "aria-expanded", "title", "onKeydown", "onClick"]

import { computed, ref, nextTick } from 'vue';
import navigationStore from '@/shared/navigation/navigation.store';
import BusinessComponent from '@/shared/layout/Business/BusinessComponent.vue';
import { NavigationItemModel } from '@/types/B2CcontentServerContract';
import navigationTrackingService from '@/shared/tracking/navigation-tracking.service';
import siteContextStore, { GlobalLabels } from '@/shared/content/site-context.store';
import useGlobalLabels from '@/shared/content/useGlobalLabels';


export default /*#__PURE__*/_defineComponent({
  __name: 'MenuItems',
  emits: ['itemActive'],
  setup(__props, { emit }) {



const globalLabels = useGlobalLabels(GlobalLabels.search);

const frontpageLink = computed(() => siteContextStore.settings.frontPageUrl);

const itemElements = ref<Element[] | any>([]);

const activeMainNavigationItem = computed<NavigationItemModel | null>(
    () => {
        return navigationStore.activeMainNavigationItem;
    },
);

const mainLeftNavigation = computed(() => {
    return navigationStore.mainLeftNavigation;
});

const mainRightNavigation = computed(() => {
    return navigationStore.mainRightNavigation;
});

const myBoliaNavigation = computed(() => {
    return navigationStore.myBoliaNavigation;
});

const onMainNavigationClick = (item: NavigationItemModel): void => {
    if (navigationStore.activeMainNavigationItem === item) {
        navigationTrackingService.menuItem(null);
        navigationStore.handleMainNavigationClick(item);
    } else {
        navigationStore.handleMainNavigationClick(item);
        navigationTrackingService.menuItem(item);
    }
};

const onSearchClick = (): void => {
    navigationTrackingService.searchLink();
    navigationStore.toggleActiveSearch();
};

const isActiveItem = (item: NavigationItemModel, i: number): boolean => {
    if (itemElements.value.length) {
        nextTick(() => {
            emit('itemActive', itemElements.value[i]);
        });
    }
    return activeMainNavigationItem?.value?.name === item.name;
};


return (_ctx: any,_cache: any) => {
  const _component_c_icon = _resolveComponent("c-icon")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("ul", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(mainLeftNavigation), (item, i) => {
          return (_openBlock(), _createElementBlock("li", {
            key: item.name + i,
            ref_for: true,
            ref: (el) => { itemElements.value[i] = el; },
            class: "flex items-center",
            role: "none"
          }, [
            _createElementVNode("a", {
              href: item.url,
              class: _normalizeClass(["main-nav-item c-magic-line", { 'c-magic-line--underline font-bold': isActiveItem(item, i) }]),
              "reserve-space-for-bold-name": item.name,
              "aria-owns": item.id,
              "aria-haspopup": "menu",
              "aria-expanded": isActiveItem(item, i),
              role: "menuitem",
              tabindex: "0",
              onKeydown: _withKeys(_withModifiers(($event: any) => (onMainNavigationClick(item)), ["prevent"]), ["enter"]),
              onClick: _withModifiers(($event: any) => (onMainNavigationClick(item)), ["prevent"])
            }, _toDisplayString(item.name), 43, _hoisted_4)
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("a", {
        href: _unref(frontpageLink),
        "aria-label": _ctx.$dictionary.get('global/a11y/gotofrontpage')
      }, [
        _createVNode(_component_c_icon, {
          name: "icon-bolia-logo-simple",
          class: "w-100 h-25 my-8 anim-nav-text-color",
          "aria-hidden": "true"
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$dictionary.get('global/a11y/gotofrontpage')), 1)
          ]),
          _: 1
        })
      ], 8, _hoisted_6)
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("ul", _hoisted_9, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(mainRightNavigation), (item, i) => {
          return (_openBlock(), _createElementBlock("li", {
            key: item.name + i,
            ref_for: true,
            ref: (el) => {
                    itemElements.value[i] = el;
                }
                ,
            class: "flex items-center",
            role: "none"
          }, [
            _createElementVNode("a", {
              href: item.url,
              class: _normalizeClass(["main-nav-item c-magic-line", {'c-magic-line--underline font-bold': isActiveItem(item, i)}]),
              "reserve-space-for-bold-name": item.name,
              "aria-owns": item.id,
              "aria-haspopup": "menu",
              "aria-expanded": isActiveItem(item, i),
              tabindex: "0",
              role: "menuitem",
              onKeydown: _withKeys(_withModifiers(($event: any) => (onMainNavigationClick(item)), ["prevent"]), ["enter"]),
              onClick: _withModifiers(($event: any) => (onMainNavigationClick(item)), ["prevent"])
            }, _toDisplayString(item.name), 43, _hoisted_10)
          ]))
        }), 128)),
        _createElementVNode("li", _hoisted_11, [
          _createElementVNode("button", {
            role: "menuitem",
            class: "anim-nav-text-color c-magic-line -mt-2 pb-4 -mb-4",
            "aria-owns": "live-search",
            "aria-haspopup": "menu",
            "aria-expanded": _unref(navigationStore).hasActiveSearch,
            title: _unref(globalLabels).searchSubmit,
            tabindex: "0",
            onKeydown: _withKeys(_withModifiers(onSearchClick, ["prevent"]), ["enter"]),
            onClick: _withModifiers(onSearchClick, ["prevent"])
          }, [
            _createVNode(_component_c_icon, {
              name: "icon-search",
              class: "h-18",
              "aria-hidden": "true"
            })
          ], 40, _hoisted_12)
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(myBoliaNavigation), (item, i) => {
          return (_openBlock(), _createElementBlock("li", {
            key: item.name + i,
            ref_for: true,
            ref: (el) => {
                    itemElements.value[i] = el;
                }
                ,
            role: "none",
            class: "flex items-center"
          }, [
            _createElementVNode("a", {
              href: item.url,
              "aria-label": _ctx.$dictionary.get('global/a11y/openmybolia'),
              role: "menuitem",
              tabindex: "0",
              "aria-owns": item.id,
              "aria-haspopup": "menu",
              "aria-expanded": isActiveItem(item, i),
              class: _normalizeClass(["c-magic-line pb-3 -mb-3", { 'c-magic-line--underline': isActiveItem(item, i) }]),
              title: item.name,
              onKeydown: _withKeys(_withModifiers(($event: any) => (onMainNavigationClick(item)), ["prevent"]), ["enter"]),
              onClick: _withModifiers(($event: any) => (onMainNavigationClick(item)), ["prevent"])
            }, [
              _createVNode(_component_c_icon, {
                name: "icon-my-bolia",
                class: "h-18 -mt-3",
                title: item.name
              }, null, 8, ["title"])
            ], 42, _hoisted_13)
          ]))
        }), 128)),
        _createVNode(BusinessComponent, {
          name: "MiniBasket",
          class: "anim-nav-text-color c-magic-line pb-3 -mb-3"
        })
      ])
    ])
  ]))
}
}

})